import { Grid } from "@mui/material";
import CustomSelect from "../../../../../../../../components/CustomSelect";
import Input from "../../../../../../../../components/Input";
import { PatientVital } from "../../../../../../../../services";
import { RESPIRATORY_OPTS, VitalFormik } from "../vital-constant";

interface RespiratoryVolumeFieldsProps {
  formik: VitalFormik;
  ind: number;
}

const RespiratoryVolumeFields = ({
  formik,
  ind,
}: RespiratoryVolumeFieldsProps) => {
  const activeVital =
    ind !== -1 ? formik.values?.patientVitals?.[ind] : undefined;

  const isSelected = activeVital?.selected ?? false;

  const getKey = (k: keyof PatientVital) => `patientVitals.${ind}.${k}`;

  const getError = (key: keyof PatientVital) => {
    const touched = (formik.touched.patientVitals as any)?.[ind]?.[key];
    const error = (formik.errors.patientVitals as any)?.[ind]?.[key];
    return touched && error ? String(error) : undefined;
  };

  return (
    <Grid container gap={2}>
      <Grid xs={2.6}>
        <CustomSelect
          name={getKey("unit")}
          placeholder="mL"
          options={RESPIRATORY_OPTS}
          value={activeVital?.unit}
          onChange={(v) => formik.setFieldValue(getKey("unit"), v)}
        />
      </Grid>
      <Grid xs={1.8}>
        <Input
          required={isSelected}
          error={getError("value")}
          textFieldProps={{
            name: getKey("value"),
            placeholder: "10",
            value: activeVital?.value,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
          }}
        />
      </Grid>
    </Grid>
  );
};
export default RespiratoryVolumeFields;
